import { mapGetters, mapState } from "vuex";
import axios from "axios";

const SQL_INJECTION =
  /union\s+select|select\s+.+\s+from|insert\s+into|delete\s+from|drop\s+table|exec(\s|\()|sleep\s*\(|or\s+1\s*=\s*1|'\s*(--|;)/i;
const BOT_SPAM =
  /<script|javascript:|on\w+\s*=|(https?:\/\/|www\.).*(https?:\/\/|www\.)/i;

export const formValidation = {
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      id_distrito: "",
      dealer: "",
      msg: "",
      hour: "",
      accept: false,
      errorMsg: {
        name: "Indique um nome válido",
        email: "Indique um email válido",
        phone: "Indique um número de telefone",
        district: "Indique uma localidade",
        dealer: "Indique um concessionário",
        accept: "Tem que aceitar a Política de Privacidade",
      },
      disclaimerText:
        "Gostaria de receber comunicações de marketing, nomeadamente promoções, eventos, novos produtos e serviços Hyundai, seja através de e-mail, telefone ou SMS e no veículo (se suportado), por forma a personalizar e a melhorar a minha experiência enquanto Cliente.",
      pending: false,
      btnLabel: "Submeter",
    };
  },
  computed: {
    ...mapState(["resumeData", "dataBO", "dealerLst", "isGov"]),
    ...mapGetters({
      getDistrict: "dealersLst/getDistrict",
      getDealersLst: "dealersLst/getDealersByDistrict",
      getDealerKeyValueById: "dealersLst/getDealerKeyValueById",
      getPdfConfig: "resumeData/getPdfConfig",
    }),
    getAcceptText() {
      return `Li e aceito a <a href='${this.dataBO.policyLink}' target="_blank">Política de privacidade</a>`;
    },
  },
  watch: {
    pending(val) {
      this.btnLabel = val ? "Carregando..." : "Submeter";
    },
  },
  methods: {
    async validadeForms(e) {
      e.preventDefault();

      for (let item in this.formFieldsState) {
        switch (item) {
          case "name":
            this.formFieldsState.name =
              this.isEmptyField(this.name) && this.validadeName(this.name);
            break;
          case "email":
            this.formFieldsState.email =
              this.validadeEmail(this.email) &&
              this.isSafeInput(this.email, { maxLength: 254 });
            break;
          case "phone":
            this.formFieldsState.phone =
              this.validadePhone(this.phone) &&
              this.isSafeInput(this.phone, { maxLength: 15 });
            break;
          case "district":
            this.formFieldsState.district =
              this.isEmptyField(this.id_distrito) &&
              this.isSafeInput(this.id_distrito, { maxLength: 50 });
            break;
          case "dealer":
            if (this.formFieldsState.district) {
              this.formFieldsState.dealer =
                this.isEmptyField(this.dealer) &&
                this.isSafeInput(this.dealer, { maxLength: 50 });
            }
            break;
          case "msg":
            this.formFieldsState.msg = this.isSafeInput(this.msg, {
              optional: true,
              maxLength: 3500,
            });
            break;
          case "accept":
            this.formFieldsState.accept = this.accept;
            break;
        }
      }

      if (Object.values(this.formFieldsState).every(Boolean)) {
        this.pending = true;

        this.dataBO?.hasPDF && await this.fetchConfigPDF();

        e.target.submit();
      }
    },
    handlePolicy(e) {
      this.accept = e;
    },
    isEmptyField(field) {
      return field == undefined || field == "" ? false : true;
    },
    validadePhone(field) {
      let testCondition = /^\d+$/;
      if (!field || field.length < 9 || field == "") {
        return false;
      }
      return testCondition.test(field);
    },
    validadeEmail(field) {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(field);
    },
    isSafeInput(value, { optional = false, maxLength = 3500 } = {}) {
      if (optional && (value == undefined || String(value).trim() === "")) {
        return true;
      }
      if (value == undefined || value === "") {
        return false;
      }
      const text = String(value).trim();
      if (!text || text.length > maxLength) {
        return false;
      }
      if (SQL_INJECTION.test(text) || BOT_SPAM.test(text) || /(.)\1{15,}/.test(text)) {
        return false;
      }
      return true;
    },
    validadeName(field) {
      if (!this.isSafeInput(field, { maxLength: 254 })) {
        return false;
      }
      return /^[\p{L}\s'.-]{2,254}$/u.test(String(field).trim());
    },
    async fetchConfigPDF() {
      try {
        const url = process.env.VUE_APP_HYU + process.env.VUE_APP_API_BO_PDF;
        const body = this.getPdfConfig;

        const res = await axios.post(url, { data: body });
        const pdfUrl = res.data;
        const msgField = document.getElementById("msg");

        if (msgField && pdfUrl) {
          this.msg += `\n PDF: ${pdfUrl}`;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
